import React from 'react';
import './Project.css';


/**
 * Project component of the AnchorTech Solutions React Website.
 * Displays the project organisation name and the organisation logo image.
 * Wraps the project organisation name logo image in a href link to the GitHub organisation home page.
 * @param {{displayName, imageUrl, linkUrl}} formattedOrgDisplayData dictionary containing the name, image and page link
 */
function Project({ formattedOrgDisplayData }) {
    return (
        <div className='Project'>
            <a href={formattedOrgDisplayData.linkUrl} target="_blank" rel="noopener noreferrer">
                <h1>{formattedOrgDisplayData.displayName}</h1>
                <img className='ProjectImg'
                    src={formattedOrgDisplayData.imageUrl}
                    alt={formattedOrgDisplayData.displayName}
                />
            </a>
        </div>
    );
}

export default Project;
